/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { CloneReportDefinitionMutationResponse, CloneReportDefinitionPathParams, CloneReportDefinition404 } from "../models/CloneReportDefinition";

export function getCloneReportDefinitionUrl(id: CloneReportDefinitionPathParams["id"]) {
  const res = { method: 'POST', url: `/report-definitions/${id}/clone` as const }
  return res
}

/**
 * @description Creates a copy of an existing report definition. The cloned definition uses the same blueprint version as the source and is not set as default.
 * @summary Clone report definition
 * {@link /report-definitions/:id/clone}
 */
export async function cloneReportDefinition(id: CloneReportDefinitionPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CloneReportDefinitionMutationResponse, ResponseErrorConfig<CloneReportDefinition404>, unknown>({ method : "POST", url : getCloneReportDefinitionUrl(id).url.toString(), ... requestConfig })
  return res.data
}